import { Directive, TemplateRef } from '@angular/core';

@Directive({
	selector: 'ng-template[aePgtFilterCustom]',
})
export class PaginationTableFiltersCustomDirective {
	constructor(public template: TemplateRef<any>) {}
}
